import styled from 'styled-components';

import { colorScheme } from '../../../theme';
import { MapButton } from '../mapButton';

const StyledButton = styled.button<{ active?: boolean }>`
  position: absolute;
  background: white;
  color: ${colorScheme.input.button};

  font-size: 1em;

  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.14902);
  box-shadow: rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px;

  z-index: 999;
  padding: 0.5em 1em;
  font-size: 16px;
  font-weight: ${(props) => (props.active ? '800' : '500')};

  &:focus,
  &:active {
    outline: none;
  }
`;

export const MapStyleButton = styled(StyledButton)`
  top: 10px;
  left: 10px;
`;

export const ButtonLoader = styled(MapButton).attrs({ isActive: true })`
    width: 54px;
    height: 54px;
    right: 50px;
    bottom: 10px;
    position: absolute;
`;
